package com.arena_web.ui.components.navigation

import androidx.compose.runtime.Composable
import org.jetbrains.compose.web.dom.A

/**
 * Real `<a href>` wrapper for SPA-navigated elements so crawlers can follow
 * internal links (onClick-only navigation leaves pages orphaned for Googlebot).
 * `display: contents` keeps the anchor out of the layout — the wrapped content
 * renders exactly as before; the click is intercepted so navigation stays
 * client-side through the router.
 */
@Composable
fun NavAnchor(
    href: String,
    onNavigate: () -> Unit,
    content: @Composable () -> Unit,
) {
    A(
        href = href,
        attrs = {
            style {
                property("display", "contents")
                property("text-decoration", "none")
                property("color", "inherit")
            }
            onClick {
                it.preventDefault()
                onNavigate()
            }
        }
    ) { content() }
}
